import { render } from "./low-kanban.vue?vue&type=template&id=60f57d9f"
import script from "./low-kanban.vue?vue&type=script&lang=js"
export * from "./low-kanban.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__